'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
    async getSettings() {
        const data = {
            method: 'get',
            url: 'settings',
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async getLogs(json) {
        const data = {
            method: 'post',
            url: 'logs?page=' + json.page,
            body: json
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async getModules() {
        const data = {
            method: 'get',
            url: 'modules'
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },

    async createSetting(json) {
        const data = {
            method: 'post',
            url: 'setting',
            body: json
        }

        const response = await api.api(data)
        if (response.status === 201) {
            notify.alert.success('Setting created successfully')
            return response.data
        }
    },

    async updateSetting(json) {
        const data = {
            method: 'put',
            url: 'setting',
            body: json
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Setting updated successfully')
            return response.data
        }
    },

    async deleteSetting(id) {
        const data = {
            method: 'delete',
            url: 'setting/' + id
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Setting deleted successfully')
            return true
        }
    }
}
